import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '../supabase/client'

const SetNewPasswordPage = () => {
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const tokenHash = searchParams.get('token_hash')
  const type = searchParams.get('type') as 'recovery'

  useEffect(() => {
    if (!tokenHash || type !== 'recovery') {
      setError('Invalid or missing reset token.')
    }
  }, [tokenHash, type])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.')
      return
    }
    const { data, error: verifyError } = await supabase.auth.verifyOtp({
      type,
      token_hash: tokenHash,
    })
    if (verifyError) {
      console.error('Verify OTP error:', verifyError.message, 'Token Hash:', tokenHash);
      setError('Invalid token. Please request a new reset email. Details logged for debugging.');
      return
    }
    const { error: updateError } = await supabase.auth.updateUser({ password: newPassword })
    if (updateError) {
      setError(updateError.message)
    } else {
      setMessage('Password updated successfully. Redirecting to login...')
      setTimeout(() => navigate('/login'), 2000)
    }
  }

  if (error) {
    return (
      <div className="container">
        <p className="error">{error}</p>
        <button onClick={() => navigate('/login')}>Back to Login</button>
      </div>
    )
  }

  return (
    <div className="container">
      <h2>Установить новый пароль</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="newPassword">Новый пароль:</label>
          <input
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Введите новый пароль"
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Подтвердите пароль:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Подтвердите новый пароль"
          />
        </div>
        {message && <div>{message}</div>}
        {error && <div className="error">{error}</div>}
        <button type="submit" className="btn">
          Сохранить пароль
        </button>
      </form>
    </div>
  )
}

export default SetNewPasswordPage
